import styled from '@emotion/styled';

import { mq } from '@/utility/mediaQuery';
import { defaultTheme } from '@/utility/theme';

export const ImageBox = styled.div(() =>
  mq({
    display: 'grid',
    gridTemplateColumns: '1fr',
    gridGap: defaultTheme.spacing.xs,
    margin: [
      `${defaultTheme.spacing.l} auto`,
      `${defaultTheme.spacing.l} auto`,
      `${defaultTheme.spacing.l} auto ${defaultTheme.spacing.xxl}`,
      `${defaultTheme.spacing.l} auto ${defaultTheme.spacing.xxl}`,
    ],
    width: ['auto', 'auto', '400px', '400px'],
    maxWidth: '400px',
    '& > p': {
      marginTop: defaultTheme.spacing.xs,
    },
  }),
);

export const CardWrapper = styled.div(() =>
  mq({
    display: 'grid',
    gridTemplateColumns: ['1fr', '1fr', 'repeat(2, 1fr)', 'repeat(2, 1fr)'],
    gridGap: [
      defaultTheme.spacing.l,
      defaultTheme.spacing.l,
      defaultTheme.spacing.xxl,
      defaultTheme.spacing.xxl,
    ],
    marginBottom: defaultTheme.spacing.xxl,
  }),
);

export const Card = styled.div(() =>
  mq({
    backgroundColor: defaultTheme.background.lightGray,
    padding: defaultTheme.spacing.xxl,
  }),
);

export const CardInnerList = styled.ul(() =>
  mq({
    fontSize: defaultTheme.font.size.s,
    fontWeight: 'bold',
    lineHeight: defaultTheme.font.height.l,
    margin: `${defaultTheme.spacing.s} 0`,
  }),
);

export const Note = styled.p(() =>
  mq({
    color: defaultTheme.text.gray,
    fontSize: defaultTheme.font.size.xs,
    marginTop: defaultTheme.spacing.xxl,
  }),
);
